type LabelGroup = Record<
    string,
    {
        forAdult: string;
        forMinor: string;
        forFutureAdult?: string;
    }
>;

const SUMMARY_GROUP_LABELS: LabelGroup = {
    ageHint: {
        forAdult: '',
        forFutureAdult:
            'Анкету требуется заполнить как от совершеннолетнего, так как на сборах вам уже будет 18 лет.',
        forMinor:
            'Анкету заполняет законный представитель или родитель, если до сборов курсанту меньше 18 лет.',
    },
};

const MEDICAL_GROUP_LABELS: LabelGroup = {
    diets: {
        forAdult: 'Диеты, какие пищевые продукты не рекомендуются',
        forMinor: 'Диеты, какие пищевые продукты не рекомендуются ребенку',
    },
    proneToCold: {
        forAdult: 'Вы склонны к простудным заболеваниям?',
        forMinor: 'Ребенок склонен к простудным заболеваниям?',
    },
    fractures: {
        forAdult:
            'Были ли у Вас переломы? Если да, укажите, какие именно и когда. Если нет, то напишите «Нет»',
        forMinor:
            'Были ли у ребенка переломы? Если да, укажите, какие именно и когда. Если нет, то напишите «Нет»',
    },
    headInjuries: {
        forAdult:
            'Были ли у Вас травмы головы с сотрясением мозга? Если да, укажите, когда. Если нет, то напишите «Нет»',
        forMinor:
            'Были ли у ребенка травмы головы с сотрясением мозга? Если да, укажите, когда. Если нет, то напишите «Нет»',
    },
    allergicDiseases: {
        forAdult:
            'Есть ли у Вас аллергические заболевания? Если да, укажите, на что именно. Если нет, то напишите «Нет»',
        forMinor:
            'Есть ли у ребенка аллергические заболевания? Если да, укажите, на что именно. Если нет, то напишите «Нет»',
    },
    allergyMedications: {
        forAdult:
            'Есть ли у Вас аллергия на какие-либо лекарства? Если да, укажите, на какие. Если нет, то напишите «Нет»',
        forMinor:
            'Есть ли у ребенка аллергия на какие-либо лекарства? Если да, укажите, на какие. Если нет, то напишите «Нет»',
    },
    chronicDiseases: {
        forAdult: 'Укажите, есть ли у Вас хронические заболевания? Если нет, то напишите «Нет»',
        forMinor: 'Укажите, есть ли у ребенка хронические заболевания? Если нет, то напишите «Нет»',
    },
    medications: {
        forAdult:
            'Принимаете ли Вы какие-либо лекарственные препараты на момент отправки в АНО «Авангард», если принимает, то какие и в каких дозах. Если нет, то напишите «Нет»',
        forMinor:
            'Принимает ли ребенок какие-либо лекарственные препараты на момент отправки в АНО «Авангард», если принимает, то какие и в каких дозах. Если нет, то напишите «Нет»',
    },
    heatTransfer: {
        forAdult: 'Как переносите солнце, жару?',
        forMinor: 'Как ребенок переносит солнце, жару?',
    },
    insectBites: {
        forAdult: 'Как вы реагируете на укусы насекомых?',
        forMinor: 'Как ребенок реагирует на укусы насекомых?',
    },
    healthSpecials: {
        forAdult: 'Иные важные медицинские показания и особенности Вашего здоровья',
        forMinor: 'Иные важные медицинские показания и особенности здоровья ребенка',
    },
    motionSickness: {
        forAdult: 'Укачивает ли Вас в транспорте?',
        forMinor: 'Укачивает ли ребенка в транспорте?',
    },
    fatigue: {
        forAdult: 'Быстрая утомляемость',
        forMinor: 'Быстрая утомляемость у ребенка',
    },
    wearingGlasses: {
        forAdult: 'Зрение, ношение очков/линз',
        forMinor: 'Зрение, ношение очков/линз у ребенка',
    },
    fearDark: {
        forAdult: 'Боязнь темноты',
        forMinor: 'Боязнь темноты у ребенка',
    },
};

const MEDICAL_GROUP_PLACEHOLDERS: LabelGroup = {
    medications: {
        forAdult: 'Например: принимаю витамин D в дозировке 2000Ме',
        forMinor: 'Например: принимает витамин D в дозировке 2000Ме',
    },
    heatTransfer: {
        forAdult: 'Например: хорошо переношу',
        forMinor: 'Например: хорошо переносит',
    },
};

const SPECIALS_GROUP_LABELS: LabelGroup = {
    wantToServe: {
        forAdult: 'В войсках какого рода Вы желаете проходить службу в будущем?',
        forMinor: 'В войсках какого рода ребенок желает проходить службу в будущем?',
    },
    sports: {
        forAdult: 'Какими видами спорта Вы занимаетесь (занимались)?',
        forMinor: 'Какими видами спорта ребенок занимается (занимался)?',
    },
    pleasureActivities: {
        forAdult: 'Чем занимаетесь с удовольствием?',
        forMinor: 'Чем занимается с удовольствием?',
    },
    specialSkills: {
        forAdult: 'Особые способности и умения',
        forMinor: 'Особые способности и умения ребенка',
    },
    unPleasureActivities: {
        forAdult: 'Чем Вы не любите заниматься?',
        forMinor: 'Чем ребенок не любит заниматься?',
    },
    stressfulSituations: {
        forAdult: 'Какая ситуация может для Вас оказаться трудной, стрессовой?',
        forMinor: 'Какая ситуация может для ребенка оказаться трудной, стрессовой?',
    },
    attitudeThings: {
        forAdult: 'Отношение к вещам (узнаете ли Вы свои вещи, имеете ли привычку терять вещи)',
        forMinor: 'Отношение к вещам (узнает ли ребенок свои вещи, имеет ли привычку терять вещи)',
    },
    characterTraits: {
        forAdult: 'Перечислите 5 наиболее выраженных черт характера, присущих Вам',
        forMinor: 'Перечислите 5 наиболее выраженных черт характера, присущих ребенку',
    },
};

const SPECIALS_GROUP_PLACEHOLDERS: LabelGroup = {
    specialSkills: {
        forAdult: 'Быстро учу стихотворения наизусть, читаю их с выражением',
        forMinor: 'Быстро учит стихотворения наизусть, читает их с выражением',
    },
    pleasureActivities: {
        forAdult: 'Например: Провожу время с друзьями и семьёй',
        forMinor: 'Например: Проводит время с друзьями и семьёй',
    },
    unPleasureActivities: {
        forAdult: 'Например: Не люблю участвовать в конкурсах',
        forMinor: 'Например: Не любит участвовать в конкурсах',
    },
    attitudeThings: {
        forAdult: 'Например: Вещи не теряю',
        forMinor: 'Например: Вещи не теряет',
    },
    badHabits: {
        forAdult: 'Например: Не курю и не употребляю алкоголь',
        forMinor: 'Например: Не курит и не употребляет алкоголь',
    },
};

const RECREATION_GROUP_LABELS: LabelGroup = {
    selfLeft: {
        forAdult: 'Выезжали ли Вы ранее на отдых самостоятельно (на 10 и более дней)?',
        forMinor: 'Выезжал ли ребенок ранее на отдых самостоятельно (на 10 и более дней)?',
    },
    mood: {
        forAdult: 'С каким настроением едете на учебные сборы?',
        forMinor: 'С каким настроением ребенок едет на учебные сборы?',
    },
};

const DOCUMENTS_GROUP_LABELS: LabelGroup = {
    title: {
        forAdult: 'Документы подпишите самостоятельно.',
        forMinor: 'Документы подписывает родитель или законный представитель.',
    },
};

const _getLabel =
    (group: LabelGroup) => (key: string, isAdult: boolean, isFutureAdult?: boolean) => {
        if (typeof group[key] === 'undefined') {
            return '';
        }

        if (isAdult) {
            return group[key].forAdult;
        }

        if (isFutureAdult) {
            return group[key].forFutureAdult || '';
        }

        return group[key].forMinor;
    };

export const getSummaryGroupLabel = _getLabel(SUMMARY_GROUP_LABELS);
export const getMedicalGroupLabel = _getLabel(MEDICAL_GROUP_LABELS);
export const getMedicalGroupPlaceholder = _getLabel(MEDICAL_GROUP_PLACEHOLDERS);

export const getSpecialsGroupLabel = _getLabel(SPECIALS_GROUP_LABELS);
export const getSpecialsGroupPlaceholder = _getLabel(SPECIALS_GROUP_PLACEHOLDERS);

export const getRecreationGroupLabel = _getLabel(RECREATION_GROUP_LABELS);
export const getDocumentsGroupLabel = _getLabel(DOCUMENTS_GROUP_LABELS);
